<template>
  <div>
    <b-tabs v-model="tabName" align="center">
      <b-tab>
        <template #title>
          <feather-icon icon="LayersIcon" />
          <span style="font-size: 13px">USPS</span>
        </template>
        <div class="p-2">
          <div class="input-group gap-5 abc flex-column">
            <div class="row mb-2">
              <b-form-radio
                v-model="shippingStatus"
                plain
                name="accountTypeoptions"
                value="destination"
                :disabled="isDisabled"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_only_destination") }}
                </h5>
              </b-form-radio>
              <b-form-radio
                v-model="shippingStatus"
                plain
                name="accountTypeoptions"
                value="shipped"
                class="ml-2"
                :disabled="isDisabled"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_shipped_from_state") }}
                </h5>
              </b-form-radio>
              <b-form-radio
                v-model="shippingStatus"
                plain
                name="accountTypeoptions"
                value="city"
                class="ml-2"
                :disabled="isDisabled"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_shipped_from_city") }}
                </h5>
              </b-form-radio>
              <b-form-radio
                v-model="shippingStatus"
                plain
                name="accountTypeoptions"
                value="state"
                class="ml-2"
                :disabled="isDisabled"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_deliver_date") }}
                </h5>
              </b-form-radio>
            </div>
            <div class="mt-4">
              <div class="row">
                <!-- File Upload Section -->
                <div class="col-lg-6 col-12 mb-4">
                  <div v-if="shippingStatus === 'destination'" class="d-flex">
                    <div style="width: 50%">
                      <file-pond
                        ref="filePond"
                        required
                        name="file"
                        label-idle="Drag & Drop your CSV file or <span class='filepond--label-action'>Browse</span>"
                        accepted-file-types="text/csv"
                        :files="myFiles"
                        :server="uploadShipped"
                      />
                    </div>
                    <div
                      class="d-flex flex-column items-center align-items-center pl-4"
                    >
                      <h6 class="fw-semibold text-center">
                        Sample File Destination Zip
                      </h6>
                      <feather-icon
                        size="40"
                        icon="FileTextIcon"
                        class="cursor-pointer"
                        @click="handleDestinationFileClick"
                      />
                    </div>
                  </div>

                  <div v-if="shippingStatus === 'shipped'" class="d-flex">
                    <div style="width: 50%">
                      <file-pond
                        ref="filePond"
                        required
                        name="file"
                        label-idle="Drag & Drop your CSV file or <span class='filepond--label-action'>Browse</span>"
                        accepted-file-types="text/csv"
                        :files="shippedFiles"
                        :server="uploadShipped"
                      />
                    </div>
                    <div
                      class="d-flex flex-column items-center align-items-center pl-4"
                    >
                      <h6 class="fw-semibold text-center">
                        Sample File Destination Zip and shipping state
                      </h6>
                      <feather-icon
                        size="40"
                        icon="FileTextIcon"
                        class="cursor-pointer"
                        @click="handleShippedFileClick"
                      />
                    </div>
                  </div>

                  <div v-if="shippingStatus === 'city'" class="d-flex">
                    <div style="width: 50%">
                      <file-pond
                        ref="filePond"
                        required
                        name="file"
                        label-idle="Drag & Drop your CSV file or <span class='filepond--label-action'>Browse</span>"
                        accepted-file-types="text/csv"
                        :files="myFiles"
                        :server="uploadShipped"
                      />
                    </div>
                    <div
                      class="d-flex flex-column items-center align-items-center pl-4"
                    >
                      <h6 class="fw-semibold text-center">
                        Sample File Shipping City and Destination City
                      </h6>
                      <feather-icon
                        size="40"
                        icon="FileTextIcon"
                        class="cursor-pointer"
                        @click="handleCityFileClick"
                      />
                    </div>
                  </div>

                  <div v-if="shippingStatus === 'state'" class="d-flex">
                    <div style="width: 50%">
                      <file-pond
                        ref="filePond"
                        required
                        name="file"
                        label-idle="Drag & Drop your CSV file or <span class='filepond--label-action'>Browse</span>"
                        accepted-file-types="text/csv"
                        :files="myFiles"
                        :server="uploadShipped"
                      />
                    </div>
                    <div
                      class="d-flex flex-column items-center align-items-center pl-4"
                    >
                      <h6 class="fw-semibold text-center">
                        Sample File Shipped from state and deliver date
                      </h6>
                      <feather-icon
                        size="40"
                        icon="FileTextIcon"
                        class="cursor-pointer"
                        @click="handleStateFileClick"
                      />
                    </div>
                  </div>
                </div>

                <!-- Rules Section -->
                <div class="col-lg-6 col-12">
                  <div
                    class="mb-2 row justify-content-between align-items-center text-center"
                  >
                    <h3>File Formatting Rules</h3>
                    <span
                      v-if="shippingStatus === 'shipped'"
                      class="text-blue cursor-pointer font-weight-bolder"
                      @click="handleStateClick"
                      >Click here to set your preffered shipping states</span
                    >
                  </div>
                  <p>
                    Please adhere to the following rules when filling out the
                    file:
                  </p>
                  <ol
                    class="list-group list-group-numbered"
                    style="font-size: 16px"
                  >
                    <li class="">
                      <strong>Max 5 days difference between dates:</strong>
                      Ensure that the dateFrom and dateTo have a maximum
                      difference of 5 days between them. This is the interval
                      you will receive tracking shipping date. Delivered by is
                      the date after you want tracking.
                    </li>
                    <li class="">
                      <strong>Same carrier per file:</strong> Include only one
                      carrier per file. Do not mix USPS, UPS, and FedEx in the
                      same file.
                    </li>
                    <li class="">
                      <strong>Date format:</strong> Use the date format
                      <code>dd/MM/yyyy or dd/MM/yy or dd-MM-yyyy</code>. For
                      example,<strong>
                        30/07/2024 or 30/07/24, 30-07-2024
                      </strong>
                      . No other format is allowed.
                    </li>
                    <li class="">
                      <strong>Tab format:</strong> Ensure each tab follows the
                      specified format for that tab. Different tabs may require
                      different formats.
                    </li>
                    <li class="">
                      <strong>Results:</strong> Check your email for the results
                      with filled TN. Approximate time for 100 numbers is 20
                      mins. Chek your email after 20 mins.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- progress bar -->
          <div v-if="isLoadingUSPS" class="progress mt-2 loading-bar">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :style="{ width: progress_u + '%' }"
              aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ progress_u }}%
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="BookOpenIcon" />
          <span style="font-size: 13px">UPS</span>
        </template>
        <UPSReport :active="tabName" />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="LayersIcon" />
          <span style="font-size: 13px">FEDEX</span>
        </template>
        <fedex :active="tabName" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BProgress,
  BModal,
  BCardText,
  BTabs,
  BTab,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import axios from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import fedex from "./fedex.vue";
import UPSReport from "./upsReports.vue";

import vueFilePond from "vue-filepond";
// eslint-disable-next-line import/no-extraneous-dependencies
import "filepond/dist/filepond.min.css";
// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import WebSocketService from "@/service/WebSocketService";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    BTable,
    BProgress,
    BBadge,
    BButton,
    BLink,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    BCardText,
    BTabs,
    BTab,
    UPSReport,
    BFormCheckbox,
    BFormRadio,
    fedex,
    //   stateOptions,
  },

  data() {
    return {
      shippingStatus: "",
      isLoadingUSPS: false,
      progress_u: 0,
      isDisabled: false,
      progress1: 0,
      progress2: 0,
      tabName: "0",
      myFiles: [],
      shippedFiles: [],
      myDestinationFiles: [],
      getResult: null,
      userEmail: null,
      sessionId: null,
      uploadShipped: {
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          const url = sessionStorage.getItem("transportURL");
          // WebSocketService.connect();
          let id = url;
          console.log("id", id);
          if (id !== null) {
            const self = this;
            const ipAddress = localStorage.getItem("ip") || "";
            const formData = new FormData();
            formData.append("multipartFile", file);
            formData.append("ipAddress", ipAddress);
            let filename = "USPS.csv";
            const request = new XMLHttpRequest();
            const token = localStorage.getItem("accessToken");
            self.isDisabled = true;
            if (this.shippingStatus === "destination") {
              request.open(
                "POST",
                `${axios.defaults.baseURL}/account/api/uploadFile-usps-only-destination-zip/${id}`
              );
              filename = "USPS_Destination.csv";
            } else if (this.shippingStatus === "shipped") {
              request.open(
                "POST",
                `${axios.defaults.baseURL}/account/api/uploadFile-usps-shipped-from-state/${id}`
              );
              filename = "USPS_Shipped.csv";
            } else if (this.shippingStatus === "city") {
              request.open(
                "POST",
                `${axios.defaults.baseURL}/account/api/uploadFile-usps-shipped-from-city/${id}`
              );
              filename = "USPS_City.csv";
            } else if (this.shippingStatus === "state") {
              request.open(
                "POST",
                `${axios.defaults.baseURL}/account/api/uploadFile-usps-shipped-from-state-delivery-date/${id}`
              );
              filename = "USPS_State.csv";
            }
            request.setRequestHeader("Authorization", `Bearer ${token}`);
            // request.upload.onprogress = (e) => {
            //   // progress(e.lengthComputable, e.loaded, e.total);
            // };
            request.onloadstart = function () {
              self.isLoadingUSPS = true;
              // self.startProgress();
            };
            WebSocketService.subscribe((message) => {
              self.progress_u = parseFloat(message.toFixed(2));

              if (self.progress_u === 100 && !self.isNotified) {
                self.isNotified = true; // Set the flag to prevent multiple notifications

                const filePond = self.$refs.filePond;
                if (filePond) {
                  self.clearFilePondFiles();
                  self.isDisabled = false;
                  self.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "File Sent Successfully",
                      icon: "EditIcon",
                      variant: "success",
                      text: `Your file has been successfully sent to ${self.userEmail}. Please check your email`,
                    },
                  });
                }

                setTimeout(() => {
                  self.isLoadingUSPS = false;
                  self.isNotified = false; // Reset the flag after the operation is complete
                }, 500);
              }
            }, `/topic/progress_${id}`);
            // eslint-disable-next-line func-names
            request.onload = function () {
              if (request.status >= 200 && request.status < 300) {
                // Notify FilePond of successful upload
                load(request.responseText);
                self.progress_u = 0;
                self.isDisabled = false;
              } else {
                self.isDisabled = false;

                self.isLoadingUSPS = false;
                // self.clearFilePondFiles();
                const filePond = self.$refs.filePond;
                const res = JSON.parse(request.response);
                const errorMessage =
                  res?.errorMessage || "Upload failed. Please try again.";
                self.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errorMessage,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                });

                // Notify FilePond of the error
                error(errorMessage);

                if (filePond) {
                  filePond.removeFile(filePond.getFile(file.id)); // Clear specific file if needed
                }
              }
            };
            request.onerror = function () {
              self.isDisabled = false;

              // Handle network errors or other unexpected issues
              const errorMessage =
                "An unexpected error occurred. Please try again.";
              self.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });

              // Notify FilePond of the error
              error(errorMessage);
            };
            request.send(formData);
            return {
              abort: () => {
                request.abort();
                self.isLoadingUSPS = false;
                abort();
                self.isDisabled = false;
              },
            };
          } else {
            const errorMessage =
              "An unexpected error occurred. Please try again.";
            self.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        },
      },
      server: {
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          const self = this;
          const formData = new FormData();
          formData.append("multipartFile", file);
          let filename = "USPS.csv";
          const request = new XMLHttpRequest();
          const token = localStorage.getItem("accessToken");

          if (this.shippingStatus === "destination") {
            this.handleDestinationFile(file);
            // request.open(
            //   "POST",
            //   `${axios.defaults.baseURL}/account/api/uploadFile-usps-only-destination-zip`
            // );
            // filename = "USPS_Destination.csv";
          } else if (this.shippingStatus === "shipped") {
            request.open(
              "POST",
              `${axios.defaults.baseURL}/account/api/uploadFile-usps-shipped-from-state`
            );
            filename = "USPS_Shipped.csv";
          } else if (this.shippingStatus === "city") {
            request.open(
              "POST",
              `${axios.defaults.baseURL}/account/api/uploadFile-usps-shipped-from-city`
            );
            filename = "USPS_City.csv";
          }
          request.setRequestHeader("Authorization", `Bearer ${token}`);
          request.upload.onprogress = (e) => {
            progress(e.lengthComputable, e.loaded, e.total);
          };
          request.onloadstart = function () {
            self.isLoadingUSPS = true;
            self.startProgress();
          };

          // eslint-disable-next-line func-names
          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              console.log("request.status", request.status);
              self.progress_u = 100;
              self.onResponse(request.response);

              // this.clearFilePondFiles();
              self.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Sent Successfully",
                  icon: "EditIcon",
                  variant: "success",
                  text: `Your file has been successfully sent to ${self.userEmail}. Please check your email`,
                },
              });
              // self.response = JSON.parse(request.response);
              // const csvContent = request.response;

              // const blob = new Blob([csvContent], {
              //   type: "text/csv;charset=utf-8;",
              // });

              // // Create a link element and trigger a download
              // const link = document.createElement("a");
              // if (link.download !== undefined) {
              //   // For browsers that support the download attribute
              //   const url = URL.createObjectURL(blob);
              //   link.setAttribute("href", url);
              //   link.setAttribute("download", filename);
              //   link.style.visibility = "hidden";
              //   document.body.appendChild(link);
              //   link.click();
              //   document.body.removeChild(link);

              //   self.$toast({
              //     component: ToastificationContent,
              //     props: {
              //       title: "File Fetched Successfully",
              //       icon: "EditIcon",
              //       variant: "success",
              //     },
              //   });
              // }

              // Notify FilePond of successful upload
              load(request.responseText);

              // Clear file input
              const filePond = self.$refs.filePond;
              if (filePond) {
                filePond.removeFile(filePond.getFile(file.id)); // Clear specific file if needed
                self.isLoadingUSPS = false;
              }
            } else {
              self.isLoadingUSPS = false;
              // self.clearFilePondFiles();
              const filePond = self.$refs.filePond;
              const res = JSON.parse(request.response);
              const errorMessage =
                res?.errorMessage || "Upload failed. Please try again.";
              self.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });

              // Notify FilePond of the error
              error(errorMessage);

              if (filePond) {
                filePond.removeFile(filePond.getFile(file.id)); // Clear specific file if needed
              }
            }
          };
          request.onerror = function () {
            // Handle network errors or other unexpected issues
            const errorMessage =
              "An unexpected error occurred. Please try again.";
            self.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });

            // Notify FilePond of the error
            error(errorMessage);
          };
          request.send(formData);
          return {
            abort: () => {
              request.abort();
              self.isLoadingUSPS = false;
              abort();
            },
          };
        },
      },
    };
  },
  watch: {
    shippingStatus(newStatus, oldStatus) {
      if (newStatus) {
        WebSocketService.connect();
      }
      if (newStatus !== oldStatus) {
        this.clearFilePondFiles();
        this.isLoadingUSPS = false;
        // WebSocketService.connect();
      }
      localStorage.setItem("usps_radio_button", newStatus);
    },
    tabName(newStatus) {
      if (String(newStatus) === "0") {
        WebSocketService.connect();
        console.log("22,", typeof this.tabName); // Output: "string"
      }
      console.log(",11", typeof this.tabName); // Output: "string"

      // WebSocketService.connect();
      localStorage.setItem("bulk_traking_tabName", newStatus);
    },
  },
  created() {
    // if (this.tabName === 0) {
    //   WebSocketService.connect();
    // }
    console.log(",", typeof this.tabName); // Output: "string"

    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      const parsedUserData = JSON.parse(storedUserData);
      this.userEmail = parsedUserData?.email || "";
    } else {
      this.userEmail = "";
    }
    const getTabName = localStorage.getItem("bulk_traking_tabName");
    if (getTabName) {
      this.tabName = getTabName;
    } else {
      localStorage.setItem("bulk_traking_tabName", this.tabName);
    }
    const val = localStorage.getItem("usps_radio_button");
    if (val) {
      this.shippingStatus = val;
    } else {
      this.shippingStatus = "destination";
      localStorage.setItem("usps_radio_button", "destination");
    }
  },
  beforeDestroy() {
    // Clean up by disconnecting from the WebSocket
    WebSocketService.disconnect();
    sessionStorage.removeItem("transportURL");
  },
  methods: {
    handleStateClick() {
      this.$router.push({ name: "settings" });
      localStorage.setItem("shippingTabNumber", 3);
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          // The result contains the Data URL, extract the Base64 part
          const base64 = reader.result.split(",")[1];
          resolve(base64);
        };

        reader.onerror = (error) => reject(error);

        // Read the file as a Data URL
        reader.readAsDataURL(file);
      });
    },
    startProgress() {
      this.progress = 0;
      this.progressInterval = setInterval(() => {
        if (this.progress < 80) {
          this.progress += 20; // Increment by 20%
        } else {
          clearInterval(this.progressInterval); // Stop incrementing at 100%
          this.progress = 98; // Ensure progress is set exactly to 100%
        }
      }, 700); // Increment every 700ms
    },
    stopProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
    },
    clearFilePondFiles() {
      const filePond = this.$refs.filePond;
      if (filePond) {
        filePond.getFiles().forEach((file) => filePond.removeFile(file.id));
      }
    },
    onResponse(r) {
      this.getResult = r;
    },
    handleDestinationFileClick() {
      const token = useJwt.getToken();
      useJwt
        .SampleFileUSPSZip(token)
        .then((response) => {
          const csvContent = response.data;
          // Create a Blob from the CSV string
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          // Create a link element and trigger a download
          const link = document.createElement("a");
          if (link.download !== undefined) {
            // For browsers that support the download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute(
              "download",
              "example-usps-only-destination-zip.csv"
            );
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "File Downloaded Successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    handleShippedFileClick() {
      const token = useJwt.getToken();
      useJwt
        .SampleFileUSPSState(token)
        .then((response) => {
          const csvContent = response.data;
          // Create a Blob from the CSV string
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          // Create a link element and trigger a download
          const link = document.createElement("a");
          if (link.download !== undefined) {
            // For browsers that support the download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute(
              "download",
              "example-usps-destination-zip-and-shipping-state.csv"
            );
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "File Downloaded Successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    handleCityFileClick() {
      const token = useJwt.getToken();
      useJwt
        .SampleFileUSPSCity(token)
        .then((response) => {
          const csvContent = response.data;
          // Create a Blob from the CSV string
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          // Create a link element and trigger a download
          const link = document.createElement("a");
          if (link.download !== undefined) {
            // For browsers that support the download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute(
              "download",
              "example-usps-shipping-city-and-destination-city.csv"
            );
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "File Downloaded Successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    handleStateFileClick() {
      const token = useJwt.getToken();
      useJwt
        .sampleFileUSPSDeliverDate(token)
        .then((response) => {
          const csvContent = response.data;
          // Create a Blob from the CSV string
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          // Create a link element and trigger a download
          const link = document.createElement("a");
          if (link.download !== undefined) {
            // For browsers that support the download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute(
              "download",
              "example-usps-shipped-from-state-delivery-date.csv"
            );
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "File Downloaded Successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>
<style lang="scss">
/*  */
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.input-group {
  box-shadow: none !important;
}

.progress {
  height: 1rem;
  width: 40%;
}

.input_container {
  border: 1px solid #e5e5e5;
}

input[type="file"]::file-selector-button {
  background-color: #fff;
  color: #000;
  border: 0px;
  border-right: 1px solid #e5e5e5;
  padding: 10px 15px;
  margin-right: 20px;
  transition: 0.5s;
}

input[type="file"]::file-selector-button:hover {
  background-color: #eee;
  border: 0px;
  border-right: 1px solid #e5e5e5;
}

.loading-bar {
  position: absolute;
  bottom: 60px;
  left: 40px;
}

.usps-container {
  display: flex;
}

.w-pond {
  width: 80%;
}
.text-blue {
  color: #007bff; /* Replace this with your desired blue color */
}
.text-blue:hover {
  text-decoration: underline; /* Adds underline on hover */
}
</style>
